/* Queenslander Aviaries - Pick N Mix builder
 * Enforces the per-group selection limits and mirrors every choice into the
 * product form as line item properties, so the blend appears on the order.
 * Scoped entirely to [data-qa-pnm]; touches nothing else on the page.
 */
(function () {
  'use strict';

  var HOLDER_CLASS = 'qa-pnm-props';

  function findForm(container) {
    var section = container.closest('.cc-main-product');
    var form = section && section.querySelector('product-form .js-product-form');
    if (!form) form = document.querySelector('product-form .js-product-form');
    return form || null;
  }

  function getHolder(form) {
    var holder = form.querySelector('.' + HOLDER_CLASS);
    if (!holder) {
      holder = document.createElement('div');
      holder.className = HOLDER_CLASS;
      holder.hidden = true;
      form.appendChild(holder);
    }
    return holder;
  }

  function addProp(holder, key, value) {
    if (!key || !value) return;
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'properties[' + key + ']';
    input.value = value;
    holder.appendChild(input);
  }

  function applyLimit(group) {
    var max = parseInt(group.getAttribute('data-max'), 10);
    var boxes = group.querySelectorAll('[data-qa-pnm-cb]');
    var chosen = [];
    var i;

    for (i = 0; i < boxes.length; i += 1) {
      if (boxes[i].checked) chosen.push(boxes[i].value);
    }

    var counter = group.querySelector('[data-qa-pnm-count]');
    if (counter && !isNaN(max)) {
      counter.textContent = chosen.length + ' of ' + max;
      group.classList.toggle('is-full', chosen.length >= max);
    }

    if (!isNaN(max)) {
      var atLimit = chosen.length >= max;
      for (i = 0; i < boxes.length; i += 1) {
        var lock = atLimit && !boxes[i].checked;
        boxes[i].disabled = lock;
        var item = boxes[i].closest('.qa-pnm__item');
        if (item) item.classList.toggle('is-locked', lock);
      }
    }

    return chosen;
  }

  function sync(container, form) {
    var holder = getHolder(form);
    holder.innerHTML = '';

    var groups = container.querySelectorAll('[data-qa-pnm-group]');
    var i;

    for (i = 0; i < groups.length; i += 1) {
      var chosen = applyLimit(groups[i]);
      if (chosen.length) {
        addProp(holder, groups[i].getAttribute('data-group'), chosen.join(', '));
      }
    }

    var texts = container.querySelectorAll('[data-qa-pnm-text]');
    for (i = 0; i < texts.length; i += 1) {
      addProp(holder, texts[i].getAttribute('data-prop'), texts[i].value.trim());
    }

    var radios = container.querySelectorAll('[data-qa-pnm-radio]');
    for (i = 0; i < radios.length; i += 1) {
      if (radios[i].checked) {
        addProp(holder, radios[i].getAttribute('data-prop'), radios[i].value);
      }
    }
  }

  function init(container) {
    if (!container || container.dataset.qaPnmReady === 'true') return;

    var form = findForm(container);
    if (!form) return;

    container.dataset.qaPnmReady = 'true';

    var update = function () {
      sync(container, form);
    };

    container.addEventListener('change', update);
    container.addEventListener('input', update);

    update();
  }

  function initAll(scope) {
    var root = scope || document;
    var nodes = root.querySelectorAll('[data-qa-pnm]');
    for (var i = 0; i < nodes.length; i += 1) {
      init(nodes[i]);
    }
  }

  function boot() {
    initAll(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (evt) {
    var target = evt.target || document;
    var nodes = target.querySelectorAll ? target.querySelectorAll('[data-qa-pnm]') : [];
    for (var i = 0; i < nodes.length; i += 1) {
      delete nodes[i].dataset.qaPnmReady;
    }
    initAll(target);
  });
}());
